import styled, { css } from 'styled-components';

import ArrowButton from 'Elements/Button/Arrow';

export const Content = styled.div`
    ${({ theme }) => css`
        height: 100%;
        padding: 4.5rem 0 0;

        @media ${theme.breakpoints.large.media} {
            padding: 6.75rem 0 0;
        }
    `}
`;

export const Heading = styled.h1`
    ${({ theme }) => css`
        margin: 0 0 2rem;
        line-height: 1.3;
        font-size: 1.875rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 2.5rem;
            line-height: 1.2;
        }
    `}
`;

export const HeadingPre = styled.span`
    ${({ theme }) => css`
        font-weight: 300;
        font-size: 1.5rem;
        color: ${({ theme }) => theme.colors.accents[3].hex};

        @media ${theme.breakpoints.large.media} {
            font-size: 2rem;
        }
    `}
`;

export const HeadingMain = styled.span`
    display: block;
`;

export const StyledArrowButton = styled(ArrowButton)`
    ${({ theme }) => css`
        margin-top: 1rem;

        @media ${theme.breakpoints.large.media} {
            margin-top: 3rem;
        }
    `}
`;
